import { createBrowserRouter, Navigate } from 'react-router-dom'
import { SignInPage, SignUpPage, ResetPasswordPage } from 'pages/auth'
import { Profile } from 'modules/Profile'
import { Fleet } from 'modules/Fleet'
import { MainLayout } from 'layouts/MainLayout'
import { URLS } from 'constants/urls'
import { Dashboard } from 'modules/Dashboard'
import { NotFound } from 'ui/molecules/NotFound'
import { UnauthorizedRoute } from 'routes/UnauthorizedRoute'
import { App } from './app'
import {
  ActivityHistoryRoute,
  ApplicationsRoute,
  BookingHistoryRoute,
  DocumentsRoute,
  DropoffFeeRoute,
  LocationsRoute,
  TermsAndConditionsRoute,
} from 'routes'
import { Join } from 'pages/Join'
import { Favorites } from 'modules/Favorites'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate replace to={URLS.SIGNIN} />,
      },
      {
        path: URLS.REGISTER,
        element: (
          <UnauthorizedRoute>
            <SignUpPage />
          </UnauthorizedRoute>
        ),
      },
      {
        path: URLS.JOIN,
        element: <Join />,
      },
      {
        path: URLS.MIGRATE,
        element: (
          <UnauthorizedRoute>
            <SignUpPage />
          </UnauthorizedRoute>
        ),
      },
      {
        path: URLS.SIGNIN,
        element: (
          <UnauthorizedRoute>
            <SignInPage />
          </UnauthorizedRoute>
        ),
      },
      {
        path: URLS.CONFIRM_REGISTRATION,
        element: (
          <UnauthorizedRoute>
            <SignInPage />
          </UnauthorizedRoute>
        ),
      },
      {
        path: URLS.FORGOT_PASSWORD,
        element: (
          <UnauthorizedRoute>
            <ResetPasswordPage />
          </UnauthorizedRoute>
        ),
      },
      {
        path: `${URLS.PROFILE}/*`,
        element: <MainLayout Content={<Profile />} />,
      },
      {
        path: `${URLS.LOCATIONS}/*`,
        element: <LocationsRoute />,
      },
      {
        path: `${URLS.DROP_OFF_FEE}/*`,
        element: <DropoffFeeRoute />,
      },
      {
        path: `${URLS.FLEET}/*`,
        element: <MainLayout Content={<Fleet />} />,
      },
      {
        path: `${URLS.TERMS_AND_CONDITIONS}/*`,
        element: <TermsAndConditionsRoute />,
      },
      {
        path: `${URLS.ACTIVITY_HISTORY}/*`,
        element: <ActivityHistoryRoute />,
      },
      {
        path: `${URLS.APPLICATIONS}/*`,
        element: <ApplicationsRoute />,
      },
      {
        path: `${URLS.DASHBOARD}/*`,
        element: <MainLayout Content={<Dashboard />} />,
      },
      {
        path: `${URLS.BOOKING_HISTORY}/*`,
        element: <BookingHistoryRoute />,
      },
      {
        path: '*',
        element: <MainLayout Content={<NotFound />} />,
      },
      {
        path: `${URLS.FAVORITES}/*`,
        element: <MainLayout Content={<Favorites />} />,
      },
      {
        path: `${URLS.DOCUMENTS}/*`,
        element: <DocumentsRoute />,
      },
    ],
  },
])
